import React from "react";
import Map from "./Map";
const _ = require("lodash");

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const GOOGLE_MAPS_API_URL = process.env.REACT_APP_GOOGLE_MAPS_API_URL;
const GOOGLE_MAPS_VERSION = "3.exp";
const GOOGLE_MAPS_LIBRARIES = "geometry,drawing,places";
let GOOGLE_MAPS_API =
  GOOGLE_MAPS_API_URL +
  "?key=" +
  GOOGLE_MAPS_API_KEY +
  "&v=" +
  GOOGLE_MAPS_VERSION +
  "&libraries=" +
  GOOGLE_MAPS_LIBRARIES;

export default class AddressPicker extends React.Component {
  componentWillMount() {
    const refs = {};

    this.setState({
      bounds: null,
      center: {
        lat:
          this.props.record.location && this.props.record.location.lat
            ? this.props.record.location.lat
            : 59.3293,
        lng:
          this.props.record.location && this.props.record.location.lng
            ? this.props.record.location.lng
            : 18.0686
      },
      markers: [],

      onMapMounted: ref => {
        refs.map = ref;
      },

      onBoundsChanged: () => {
        this.setState({
          bounds: refs.map.getBounds(),
          center: refs.map.getCenter()
        });
      },

      onCenterChanged: (lat, lng) => {
        this.setState({
          center: {
            lat: lat,
            lng: lng
          }
        });
      },

      onSearchBoxMounted: ref => {
        refs.searchBox = ref;
      },

      onMapClick: e => {
        let coordinates = {
          lat: e.latLng.lat(),
          lng: e.latLng.lng()
        };

        let geocoder = new window.google.maps.Geocoder();

        let LatLng = new window.google.maps.LatLng(
          coordinates.lat,
          coordinates.lng
        );

        const context = this;
        geocoder.geocode({location: LatLng}, function(result, status) {
          if (status === "OK") {
            let formattedAddress = result[0].formatted_address;
            let address = {...coordinates, address: formattedAddress};
            context.props.setDefaultAddress(address);
          }
        });
      },

      onPlacesChanged: () => {
        const places = refs.searchBox.getPlaces();
        const bounds = new window.google.maps.LatLngBounds();

        places.forEach(place => {
          if (place.geometry.viewport) {
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });

        let coordinates = {
          address: places[0].formatted_address,
          lat: places[0].geometry.location.lat(),
          lng: places[0].geometry.location.lng()
        };

        this.props.setDefaultAddress(coordinates);

        const nextMarkers = places.map(place => ({
          position: place.geometry.location
        }));

        const nextCenter = _.get(nextMarkers, "0.position", this.state.center);
        this.setState({
          center: nextCenter,
          markers: nextMarkers
        });
        refs.map.fitBounds(bounds);
      }
    });
  }

  componentDidMount() {
    if (!this.props.record || !this.props.record.location) {
      this.setAddress();
    }
  }

  componentDidUpdate() {
    if (this.props.record && this.props.record.location === null) {
      this.setAddress();
    }
  }

  setAddress() {
    function isFunction(functionToCheck) {
      return (
        functionToCheck &&
        {}.toString.call(functionToCheck) === "[object Function]"
      );
    }
    let centerLat = isFunction(this.state.center.lat);
    let centerLng = isFunction(this.state.center.lng);

    this.props.setDefaultAddress({
      address: " ",
      lat: centerLat ? this.state.center.lat() : this.state.center.lat,
      lng: centerLng ? this.state.center.lng() : this.state.center.lng
    });
  }

  render() {
    return (
      <Map
        store={this.props.record}
        onPlaceSelected={this.props.setDefaultAddress}
        setCenterOnPlaceSelected={this.state.onCenterChanged}
        onMapClick={this.state.onMapClick}
        onMapMounted={this.state.onMapMounted}
        onBoundsChanged={this.state.onBoundsChanged}
        onPlacesChanged={this.state.onPlacesChanged}
        marker={this.state.markers}
        location={{lat: this.props.address.lat, lng: this.props.address.lng}}
        bounds={this.state.bounds}
        center={this.state.center}
        onSearchBoxMounted={this.state.onSearchBoxMounted}
        googleMapURL={GOOGLE_MAPS_API}
        loadingElement={<div style={{height: `100%`}} />}
        containerElement={<div style={{height: `355px`, width: `710px`}} />}
        mapElement={<div style={{height: `100%`}} />}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CRM/Stores/AddressPicker.js